module.exports = __webpack_public_path__ + "images/mobile/dingtalk_home-2e5b1daa647181430a09b8f39ef53a18.png";